import {
  IsNotEmpty,
  IsOptional,
  IsIn,
  ValidateNested,
  IsArray,
  IsDateString,
} from "class-validator";
import { Type } from "class-transformer";

import { Constants } from "@eagerdog/constants";

import { IncentiveParamsMinNumberOfShowTypesDto } from "./incentive-params-number-of-show-types.dto";
import { IIncentive } from "./incentive.interface";
import { IncentiveParamsNumberOfEntriesDto } from "./incentive-params-number-of-entries.dto";
import { IncentiveParamsNumberOfEntriesFeePercentageDto } from "./incentive-params-number-of-entries-fee-percentage.dto";
import { IncentiveParamsNumberOfShowsDto } from "./incentive-params-number-of-shows.dto";
import { IncentiveParamsDogsPerShowDto } from "./incentive-params-dogs-per-show.dto";
import { IncentiveParamsAllOfferedClassesDto } from "./incentive-params-all-offered-classes.dto";

export class IncentiveDto
  implements Omit<IIncentive, "_id" | "club_id" | "event_id">
{
  @IsNotEmpty()
  @IsIn(Object.values(Constants.incentive_type))
  incentive_type: string = Constants.incentive_type.min_number_of_show_types;

  @IsOptional()
  @ValidateNested()
  @Type(() => IncentiveParamsMinNumberOfShowTypesDto)
  min_number_of_show_types?: IncentiveParamsMinNumberOfShowTypesDto;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesDto)
  number_of_entries?: IncentiveParamsNumberOfEntriesDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesDto)
  number_of_entries_per_event_number?: IncentiveParamsNumberOfEntriesDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesDto)
  number_of_entries_per_day?: IncentiveParamsNumberOfEntriesDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesDto)
  number_of_entries_per_show?: IncentiveParamsNumberOfEntriesDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesDto)
  number_of_entries_per_event?: IncentiveParamsNumberOfEntriesDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsDogsPerShowDto)
  dogs_per_show?: IncentiveParamsDogsPerShowDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsAllOfferedClassesDto)
  all_offered_classes?: IncentiveParamsAllOfferedClassesDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesFeePercentageDto)
  number_of_entries_fee_percentage?: IncentiveParamsNumberOfEntriesFeePercentageDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfShowsDto)
  number_of_shows?: IncentiveParamsNumberOfShowsDto[];

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => IncentiveParamsNumberOfEntriesDto)
  number_of_entries_per_event_per_dog?: IncentiveParamsNumberOfEntriesDto[];

  @IsOptional()
  @IsDateString()
  expires_at?: string;
}
